import { render, staticRenderFns } from "./fulfillments.vue?vue&type=template&id=27b27703"
import script from "./fulfillments.vue?vue&type=script&lang=js"
export * from "./fulfillments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports